import { createAction, createSlice } from "@reduxjs/toolkit";

import listFactory from "../../../store/listFactory";

import type { UUID } from "../../../utils";
import type { ObjectWithId } from "../../../utils/ObjectWithId";
import type { CustomerFormValues } from "../components/customer-form-content/forms/CustomerForm";
import type { Customer } from "../models/Customer";

const { slicePart, selectors } = listFactory<Customer>("customers");

export const initialState = {
  ...slicePart.initialState,
  banksByCountry: [],
  banksCountByCountry: [],
};

export const slice = createSlice({
  ...slicePart,
  initialState,
  reducers: {
    setItem: slicePart.reducers.setItem,
    setList: slicePart.reducers.setList,
    addItem: slicePart.reducers.addItem,
    updateItem: slicePart.reducers.updateItem,
    setCustomerBanksByCountry: (state, action) => {
      state.banksByCountry = action.payload;
    },
  },
});

export const {
  setList,
  setItem,
  addItem,
  updateItem,
  setCustomerBanksByCountry,
} = slice.actions;

export const fetchCustomers = createAction<
  { customerId?: UUID | UUID[]; search?: string } | undefined
>("fetchCustomers");

export const fetchCustomer = createAction<ObjectWithId, "fetchCustomer">(
  "fetchCustomer"
);

export const createCustomer = createAction<
  Omit<CustomerFormValues, "parentSearch">
>("createCustomer");

export const updateCustomer = createAction<{
  id: UUID;
  data: Omit<CustomerFormValues, "parentSearch">;
  accountsToOverride?: number;
}>("updateCustomer");

export const updateCustomerBanksByCountry = createAction<{
  id: UUID;
  countries: string[];
}>("updateCustomerBanksByCountry");
export const fetchCustomerBanksByCountry = createAction<ObjectWithId>(
  "fetchCustomerBanksByCountry"
);

export const {
  selectList: selectCustomers,
  selectItem: selectCustomer,
} = selectors;

export const selectCustomerBanksByCountry = (state: any) =>
  state.customers.banksByCountry;

export const customerOperationPaths = (id?: UUID | null) => {
  return {
    listing: ["customers.list"],
    details: ["customers", "items", "details", id],
    update: ["customers", "items", "update", id],
    create: ["customers", "create"],
  };
};

export const customersOperationPaths = {
  banksByCountry: ["customers", "banks", "count"],
  banksUpdate: ["customers", "banks", "update"],
} as const;

export default slice.reducer;
